<script>
import appConfig from '@/app.config'
import { getSmsClient } from '@/services/sms'
import { Helper, debounce } from '@/mixin/helper'

const vsmsSmsAxios = getSmsClient()

export default {
  page: {
    title: 'Detail Time Log',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  mixins: [Helper],
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalPages: 1,
      pageOptions: [10, 25, 50, 100],
      detailTimeLogList: [],
      isSort: false,
      filter: null,
      totalRows: 1,
      filteredItems: [],
      loading: false,
      sortBy: 'wo_number',
      sortDesc: false,
      startWoStartedAt: new Date().toISOString().slice(0, 10),
      endWoStartedAt: new Date().toISOString().slice(0, 10),
      tempStartWoStartedAt: new Date().toISOString().slice(0, 10),
      tempEndWoStartedAt: new Date().toISOString().slice(0, 10),
      isLoading: false,
    }
  },
  created() {
    this.getDetailTimeLog()
  },
  computed: {
    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)
        return this.detailTimeLog.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.detailTimeLog
      }
    },
    detailTimeLog() {
      return [
        {
          key: 'technician',
          label: this.$t('workOrder.table.technician'),
          sortable: true,
        },
        {
          key: 'wo_number',
          label: this.$t('workOrder.table.woNumber'),
          sortable: true,
        },
        {
          key: 'imei',
          label: this.$t('master.list.tracker.imei'),
          sortable: true,
        },
        {
          key: 'license_plate',
          label: this.$t('master.form.fleet.licensePlate'),
          sortable: true,
        },
        {
          key: 'plan_date',
          label: this.$t('workTime.column.planDate'),
          sortable: true,
        },
        {
          key: 'wo_started_at',
          label: this.$t('workOrder.table.start'),
          sortable: true,
        },
        {
          key: 'task_created_at',
          label: this.$t('workOrder.table.addVehicles'),
          sortable: true,
        },
        {
          key: 'installation_at',
          label: this.$t('workOrder.table.installationTime'),
          sortable: true,
        },
        {
          key: 'task_ended_at',
          label: this.$t('workOrder.table.validation'),
          sortable: true,
        },
        {
          key: 'task_verified_at',
          label: this.$t('workOrder.table.technicianFinished'),
          sortable: true,
        },
        {
          key: 'wo_done_at',
          label: this.$t('workOrder.table.coordinatorFinished'),
          sortable: true,
        },
        {
          key: 'valid_by_username',
          label: this.$t('task.column.validBy'),
          sortable: true,
        },
        {
          key: 'done_by_username',
          label: this.$t('workOrder.table.doneBy'),
          sortable: true,
        },
        {
          key: 'processing_time',
          label: this.$t('workOrder.table.processingTimeHours'),
          sortable: true,
        },
      ]
    },
  },
  methods: {
    async getDetailTimeLog() {
      this.loading = true
      const qp = {
        page: this.currentPage,
        size: this.perPage,
        q: this.filter,
      }
      if (this.startWoStartedAt) {
        qp.filters = qp.filters
          ? qp.filters + `;startedOn:gte:${this.startWoStartedAt}`
          : `startedOn:gte:${this.startWoStartedAt}`
      }
      if (this.endWoStartedAt) {
        qp.filters = qp.filters
          ? qp.filters + `;startedOn:lte:${this.endWoStartedAt}`
          : `startedOn:lte:${this.endWoStartedAt}`
      }
      const respDetailTimeLogList = await vsmsSmsAxios
        .get('work-order/detail-time-log', { params: qp })
        .catch((error) => {
          this.handleError(error)
        })
      if (!respDetailTimeLogList?.data?.data) {
        this.loading = false
        this.onFiltered([])
        return
      }
      this.detailTimeLogList = respDetailTimeLogList.data.data
      this.filteredItems = respDetailTimeLogList.data.data
      this.totalRows = respDetailTimeLogList.data.total_count
      this.currentPage = respDetailTimeLogList.data.page
      this.perPage = respDetailTimeLogList.data.size
      this.totalPages = respDetailTimeLogList.data.total_pages
      for (const dtl of this.detailTimeLogList) {
        dtl.processing_time_hours =
          this.getHourDifference(new Date(dtl.wo_ended_at), new Date(dtl.wo_started_at)).toFixed(
            2
          ) < 0
            ? 0
            : this.getHourDifference(
                new Date(dtl.wo_ended_at),
                new Date(dtl.wo_started_at)
              ).toFixed(2)
      }
      this.loading = false
    },

    async exportDetailTimeLog() {
      this.isLoading = true
      const qp = {
        q: this.filter,
      }
      if (this.startWoStartedAt) {
        qp.filters = qp.filters
          ? qp.filters + `;startedOn:gte:${this.startWoStartedAt}`
          : `startedOn:gte:${this.startWoStartedAt}`
      }
      if (this.endWoStartedAt) {
        qp.filters = qp.filters
          ? qp.filters + `;startedOn:lte:${this.endWoStartedAt}`
          : `startedOn:lte:${this.endWoStartedAt}`
      }
      const respDetailTimeLogExport = await vsmsSmsAxios
        .get('work-order/detail-time-log/export', {
          responseType: 'blob',
          headers: {
            'Accept-Language': process.env.VUE_APP_I18N_LOCALE,
          },
          params: qp,
        })
        .catch((error) => {
          this.isLoading = false
          this.handleError(error)
        })

      if (!respDetailTimeLogExport?.data) return

      const url = window.URL.createObjectURL(respDetailTimeLogExport.data)
      const a = document.createElement('a')
      a.href = url
      a.download = 'DetailTimeLog.xlsx'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      this.isLoading = false
    },

    getHourDifference(datetime1, datetime2) {
      var milliSecond = datetime1.getTime() - datetime2.getTime()
      var hour = milliSecond / (1000 * 60 * 60)
      return hour
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 400) {
          if (error.response.data.details) {
            error.response.data.details.forEach((element) => {
              this.$toast.error(
                `${error.response.data.error} : ${element.field} ${element.message}`
              )
            })
          }
        } else {
          this.$toast.error(error.response.data.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.filteredItems = filteredItems
      this.currentPage = 1
    },

    disabledRangeStart: function (date) {
      return (
        date >= new Date() ||
        (this.tempEndWoStartedAt ? date > new Date(this.tempEndWoStartedAt) : false)
      )
    },

    disabledRangeEnd: function (date) {
      let endDateLimit = new Date(this.tempStartWoStartedAt)
      endDateLimit.setDate(endDateLimit.getDate() - 1)

      return date >= new Date() || date < endDateLimit
    },

    resetFilter(e) {
      this.currentPage = 1
      this.size = e
      this.getDetailTimeLog()
    },

    changePage(e) {
      this.currentPage = e
      this.getDetailTimeLog()
    },

    searchData: debounce(function () {
      this.getDetailTimeLog()
    }, 600),

    async submitFilter() {
      this.startWoStartedAt = this.tempStartWoStartedAt
      this.endWoStartedAt = this.tempEndWoStartedAt
      this.getDetailTimeLog()
    },
  },
}
</script>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <b-row>
                <b-col sm="12" md="3">
                  <div class="mb-3">
                    <b-form-group
                      id="start_wo_started_at"
                      :label="$t('workTime.form.startWoStartedAt')"
                      label-for="start_wo_started_at"
                    >
                      <date-picker
                        v-model="tempStartWoStartedAt"
                        format="DD MMM YYYY"
                        value-type="YYYY-MM-DD"
                        :placeholder="$t('workTime.form.startWoStartedAt')"
                        :first-day-of-week="1"
                        :disabled-date="disabledRangeStart"
                        lang="en"
                        confirm
                      />
                    </b-form-group>
                  </div>
                </b-col>
                <b-col sm="12" md="3">
                  <div class="mb-3">
                    <b-form-group
                      id="end_wo_started_at"
                      :label="$t('workTime.form.endWoStartedAt')"
                      label-for="end_wo_started_at"
                    >
                      <date-picker
                        v-model="tempEndWoStartedAt"
                        format="DD MMM YYYY"
                        value-type="YYYY-MM-DD"
                        :placeholder="$t('workTime.form.endWoStartedAt')"
                        :first-day-of-week="1"
                        :disabled-date="disabledRangeEnd"
                        lang="en"
                        confirm
                      />
                    </b-form-group>
                  </div>
                </b-col>
                <b-col sm="12" md="3" class="d-flex align-items-end">
                  <div class="mb-3">
                    <b-form-group id="submit_plan_date">
                      <b-button variant="primary" type="button" @click="submitFilter">
                        {{ this.$t('global.submit') }}
                      </b-button>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <div class="float-end">
                <b-button
                  class="mr-3"
                  variant="primary"
                  type="button"
                  @click="exportDetailTimeLog"
                  :disabled="!(detailTimeLogList.length > 0) || isLoading"
                >
                  <b-spinner v-if="isLoading" small type="grow"></b-spinner>
                  {{ this.$t('global.export') }}
                </b-button>
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="`${$t('global.search')}...`"
                    class="ms-2"
                    @input="searchData"
                  ></b-form-input>
                </label>
              </div>
            </div>

            <div class="table-responsive my-3 border border-1">
              <b-table
                class="datatables"
                :items="detailTimeLogList"
                :fields="visibleFields"
                responsive="sm"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(plan_date)="data">
                  {{ data.item.plan_date ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(wo_started_at)="data">
                  {{ data.item.wo_started_at ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(task_created_at)="data">
                  {{ data.item.task_created_at ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(task_ended_at)="data">
                  {{ data.item.task_ended_at ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(installation_at)="data">
                  {{ data.item.installation_at ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(task_verified_at)="data">
                  {{ data.item.task_verified_at ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(wo_done_at)="data">
                  {{ data.item.wo_done_at ? momentDMHms(data.value) : '-' }}
                </template>
                <template #cell(valid_by_username)="data">
                  {{ data.item.valid_by_username ?? '-' }}
                </template>
                <template #cell(done_by_username)="data">
                  {{ data.item.done_by_username ?? '-' }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length" v-if="!loading">
                  <label class="d-inline-flex align-items-center">
                    <span>Menampilkan</span>
                    <span>
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="resetFilter"
                      />
                    </span>
                    <span>entri.&nbsp;&nbsp;</span>
                    <span
                      >Menampilkan&nbsp;
                      <strong>
                        {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
                      </strong>
                      &nbsp;sampai&nbsp;
                      <strong>
                        {{
                          currentPage != totalPages
                            ? currentPage * perPage
                            : (currentPage - 1) * perPage + filteredItems.length
                        }}
                      </strong>
                      &nbsp;dari&nbsp;
                      <strong>{{ totalRows }}</strong>
                      &nbsp;entri.
                    </span>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-if="!loading"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="changePage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
